export default __webpack_public_path__ + "static/media/pantry1-afterG-2048w.95cbe728.webp";